// extracted by mini-css-extract-plugin
export var banner = "_ns-0";
export var settingRow = "_ns-2";
export var titleIcon = "_ns-1";